import { render, staticRenderFns } from "./LogoUpload2.vue?vue&type=template&id=17721dfc&"
import script from "./LogoUpload2.vue?vue&type=script&lang=js&"
export * from "./LogoUpload2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports